import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { serverApi } from '../../api';

const MySwal = withReactContent(Swal);

export const NuevoVendedorModal = ({ show, onClose, onSuccess, vendedorToEdit = null }) => {
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        codigoVendedor: '',
        nombreVendedor: '',
        emailVendedor: '',
        password: '',
        indActivo: 1,
    });

    useEffect(() => {
        if (vendedorToEdit) {
            setForm({
                codigoVendedor: vendedorToEdit.codigoVendedor,
                nombreVendedor: vendedorToEdit.nombreVendedor,
                emailVendedor: vendedorToEdit.emailVendedor,
                password: '', // Opcional al editar
                indActivo: vendedorToEdit.indActivo,
            });
        } else {
            setForm({
                codigoVendedor: '',
                nombreVendedor: '',
                emailVendedor: '',
                password: '',
                indActivo: 1,
            });
        }
    }, [vendedorToEdit, show]);

    if (!show) return null;

    const isEdit = Boolean(vendedorToEdit);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm(prev => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.codigoVendedor || !form.nombreVendedor || !form.emailVendedor || (!isEdit && !form.password)) {
            return MySwal.fire('Atención', 'Complete los campos requeridos', 'warning');
        }

        try {
            setLoading(true);
            const endpoint = '/superadmin/vendedores';
            const method = isEdit ? 'put' : 'post';

            const resp = await serverApi[method](endpoint, form);

            if (resp.data.ok) {
                MySwal.fire({
                    title: isEdit ? '¡Vendedor Actualizado!' : '¡Vendedor Creado!',
                    text: resp.data.msg,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
                onSuccess();
                onClose();
            }
        } catch (error) {
            const msg = error.response?.data?.msg || 'Error al procesar vendedor';
            MySwal.fire('Error', msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.65)',
            backdropFilter: 'blur(6px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: 20,
            fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: 24,
                width: '100%',
                maxWidth: 500,
                boxShadow: '0 25px 60px rgba(0,0,0,0.25)',
                border: '1px solid #e2e8f0',
                overflow: 'hidden',
            }}>
                <div style={{
                    background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)',
                    padding: '20px 24px',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18 }}>
                        {isEdit ? '✏️ Editar Vendedor' : '👤 Crear Nuevo Vendedor'}
                    </h4>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'rgba(255,255,255,0.15)',
                            border: 'none',
                            color: 'white',
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            fontSize: 16,
                            cursor: 'pointer',
                        }}
                    >
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: 24 }}>
                    <div style={{ marginBottom: 14 }}>
                        <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Código Vendedor *</label>
                        <input
                            id="codigoVendedor"
                            type="text"
                            value={form.codigoVendedor}
                            onChange={handleChange}
                            placeholder="Ej: VEND-001"
                            disabled={isEdit}
                            required
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: 10,
                                border: '1.5px solid #cbd5e1', marginTop: 4, boxSizing: 'border-box',
                                background: isEdit ? '#f1f5f9' : 'white',
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: 14 }}>
                        <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Nombre Completo *</label>
                        <input
                            id="nombreVendedor"
                            type="text"
                            value={form.nombreVendedor}
                            onChange={handleChange}
                            placeholder="Ej: Juan Pérez"
                            required
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: 10,
                                border: '1.5px solid #cbd5e1', marginTop: 4, boxSizing: 'border-box',
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: 14 }}>
                        <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Email Vendedor *</label>
                        <input
                            id="emailVendedor"
                            type="email"
                            value={form.emailVendedor}
                            onChange={handleChange}
                            placeholder="vendedor@empresa.com"
                            required
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: 10,
                                border: '1.5px solid #cbd5e1', marginTop: 4, boxSizing: 'border-box',
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: 18 }}>
                        <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>
                            {isEdit ? 'Cambiar Contraseña (opcional)' : 'Contraseña *'}
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={form.password}
                            onChange={handleChange}
                            placeholder="••••••••"
                            required={!isEdit}
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: 10,
                                border: '1.5px solid #cbd5e1', marginTop: 4, boxSizing: 'border-box',
                            }}
                        />
                    </div>

                    {isEdit && (
                        <div style={{ marginBottom: 20 }}>
                            <label style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>Estado</label>
                            <select
                                id="indActivo"
                                value={form.indActivo}
                                onChange={handleChange}
                                style={{
                                    width: '100%', padding: '10px 12px', borderRadius: 10,
                                    border: '1.5px solid #cbd5e1', marginTop: 4, boxSizing: 'border-box',
                                }}
                            >
                                <option value={1}>Activo</option>
                                <option value={0}>Inactivo</option>
                            </select>
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 24 }}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                padding: '10px 18px', borderRadius: 10,
                                border: '1.5px solid #cbd5e1', background: 'white',
                                color: '#475569', fontWeight: 700, cursor: 'pointer',
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                padding: '10px 24px', borderRadius: 10,
                                border: 'none', background: 'linear-gradient(135deg, #0d7367 0%, #14b8a6 100%)',
                                color: 'white', fontWeight: 800, cursor: 'pointer',
                                boxShadow: '0 4px 14px rgba(13,115,103,0.3)',
                            }}
                        >
                            {loading ? 'Guardando...' : (isEdit ? '✓ GUARDAR CAMBIOS' : '✓ CREAR VENDEDOR')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
